import type { HotelOption, HotelRoom } from '../../types';
import { createVioParams } from './vioWhitelabel';

type Props = {
    destinationContext?: HotelOption;
    startDate?: Date;
    endDate?: Date;
    rooms: HotelRoom[];
};

export const HotelHiddenInputs = ({ destinationContext, startDate, endDate, rooms }: Props) => {
    if (destinationContext?.objectId) {
        const values = createVioParams(destinationContext, startDate, endDate, rooms);

        return (
            <>
                {Object.entries(values).map(([key, value]) => (
                    <input type="hidden" name={key} value={value} />
                ))}
            </>
        );
    }
};
